<ion-content scroll-y="false">
    <rwidget-alert></rwidget-alert>
    <!-- <div class="inner-content" ridangoAppTrapFocus> -->
    <div class="inset-0 flex items-center justify-center" ridangoAppTrapFocus>
        <div class="flex-align-center ion-align-items-center !flex h-full justify-center text-base">
            <div
                class="flex h-full w-full flex-col rounded-2xl bg-white text-base dark:border-2 dark:border-solid dark:border-contrast-yellow">
                <div class="fixed-transform-fix bg-white p-4">
                    <div class="relative flex w-full items-center justify-center py-2 pb-4 pt-0">
                        <h2
                            class="var-app-light-dark:font-bold orb-app-light:font-bold text-center text-base font-semibold leading-5"
                            id="via-point-modal-header">
                            {{ 'JOURNEY_PLANNER_VIA_POINT' | translate }}
                        </h2>
                        <div class="absolute right-0">
                            <button
                                [attr.aria-label]="'CLOSE_ARIA_LABEL' | translate"
                                (click)="closeModal()"
                                mat-icon-button>
                                <mat-icon class="text-grey-zambezy">close</mat-icon>
                            </button>
                        </div>
                    </div>

                    <div>
                        <ion-searchbar
                            class="rounded-lg border-0 p-0 text-contrast-black dark:bg-contrast-yellow dark:text-contrast-black"
                            id="via-point-modal-search"
                            [placeholder]="'JOURNEY_PLANNER_ENTER_STOP_NAME' | translate"
                            [searchIcon]="(assetsPath$ | async) + '/img/explore/search_icon.svg'"
                            [value]="searchInputValue"
                            (ionInput)="filterStops($event)"
                            show-clear-button="never"
                            mode="ios">
                        </ion-searchbar>
                    </div>
                </div>

                <div class="flex-1 overflow-y-auto bg-white pb-4">
                    <ng-container *ngIf="searchTerm$ | async as currentSearchTerm">
                        <ng-container *ngIf="displayedStops$ | async as displayedStops">
                            <ion-list *ngIf="displayedStops.length" mode="ios" lines="full">
                                <ion-item *ngFor="let stop of displayedStops" (click)="toggleStop(stop)" button="true">
                                    <ion-icon
                                        class="mr-3 text-lg text-secondary dark:filter-yellow"
                                        src="{{ assetsPath$ | async }}/img/journey-planner/via-point.svg"
                                        slot="start">
                                    </ion-icon>
                                    <ion-label class="py-2">
                                        {{ stop.name }}
                                        <div
                                            class="text-xs font-medium leading-4 text-grey-zambezy dark:text-contrast-yellow"
                                            *ngIf="stop.code">
                                            {{ stop.code }}
                                        </div>
                                    </ion-label>
                                </ion-item>
                            </ion-list>

                            <div
                                class="flex items-center justify-center p-8"
                                *ngIf="(currentSearchTerm?.length ?? 0) < minSearchCharacters">
                                <p class="text-ironside_grey">{{ 'JOURNEY_PLANNER_ENTER_STOP_NAME' | translate }}</p>
                            </div>

                            <div
                                class="flex items-center justify-center p-8"
                                *ngIf="
                                    (currentSearchTerm?.length ?? 0) >= minSearchCharacters && !displayedStops.length
                                ">
                                <p class="text-ironside_grey">{{ 'JOURNEY_PLANNER_NO_STOPS_FOUND' | translate }}</p>
                            </div>

                            <div
                                class="fixed-transform-fix bg-white p-4"
                                *ngIf="(hasMoreStops$ | async) && displayedStops.length">
                                <button
                                    class="var-app-light:text-black var-app-light-dark:font-semibold h-14 w-full rounded-lg bg-secondary font-bold text-white dark:bg-contrast-yellow dark:text-contrast-black"
                                    (click)="loadMoreStops()">
                                    {{ 'LOAD_MORE_STOPS' | translate }}
                                </button>
                            </div>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</ion-content>
